import React from "react";
import "./CardPromotion.css";

const promotions = [
  {
    id: 1,
    image: "/assets/bcimages/promotion/promotion-img-1.png",
    title: "Deposit Bonus In casino",
    endTime: "",
    extraImage: null,
  },
  {
    id: 2,
    image: "/assets/bcimages/promotion/promotion-img-2.png",
    title: "Deposit Bonus In casino",
    endTime: "",
    extraImage: null,
  },
  {
    id: 3,
    image: "/assets/bcimages/promotion/bcpromotion1.avif",
    title: " x Leicester City",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },
  {
    id: 4,
    image: "/assets/bcimages/promotion/bcpromotion2.avif",
    title: "New Members Bonuses",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },
  {
    id: 5,
    image: "/assets/bcimages/promotion/bcpromotion3.avif",
    title: "Cricket Triple Winnings!",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },
 
  {
    id: 7,
    image: "/assets/bcimages/promotion/bcpromotion5.avif",
    title: "LaLiga 3 Scores Stake",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },
  {
    id: 8,
    image: "/assets/bcimages/promotion/bcpromotion6.avif",
    title: "Horse Racing Betting",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },

  {
    id: 9,
    image: "/assets/bcimages/promotion/bcpromotion7.avif",
    title: "100% 1st Bet Return",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },



  {
    id: 11,
    image: "/assets/bcimages/promotion/bcpromotion9.avif",
    title: "CocoRush Christmas",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },
  
  {
    id: 13,
    image: "/assets/bcimages/promotion/bcpromotion11.avif",
    title: "NFL Stake Back ",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },
  {
    id: 14,
    image: "/assets/bcimages/promotion/bcpromotion12.avif",
    title: "Evolution x ",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },
  {
    id: 15,
    image: "/assets/bcimages/promotion/bcpromotion13.avif",
    title: "NBA Betting Insurance",
    endTime: "Ends 5/26/2025, 5:29:59 AM",
    extraImage: "/assets/bcimages/promotion/starimg.webp",
  },


  
];

const CardPromotion = () => {
  return (
    <div className="main-card-promot">
      {promotions.map((promotion) => (
        <div key={promotion.id} className="CardPromotion-main-in">
          <div className="bc-promotion-main">
            <img
              style={{ borderRadius: "10px" }}
              className="bcpromotionimg"
              src={promotion.image}
              alt={promotion.title}
            />
            {promotion.extraImage && (
              <img
                className="rank-img"
                src={promotion.extraImage}
                alt="Extra Icon"
              />
            )}
          </div>
          <div className="casino-button-in">
            <div style={{ paddingTop: "10px" }}>
              <div className="deposite-heading">{promotion.title}</div>
              {promotion.endTime && (
                <div className="casino-button-in-time">{promotion.endTime}</div>
              )}
            </div>
            <h4 className="casino-progress">In Progress</h4>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardPromotion;
